// Ruta: frontend/src/modules/inspections/pages/InspectionPage.tsx
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom'; // ✅ Eliminado 'Link'
import { inspectionService } from '@core/services/inspectionService';
import { Inspection } from '@core/types';
import { Button } from '@shared/components/Button';

const InspectionPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [inspection, setInspection] = useState<Inspection | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) return;
    const load = async () => {
      try {
        const data = await inspectionService.getById(id);
        setInspection(data);
      } catch (error) {
        console.error('Error cargando inspección:', error);
      } finally {
        setIsLoading(false);
      }
    };
    load();
  }, [id]);

  if (isLoading) {
    return <div className="text-center py-12 text-gray-500">Cargando inspección...</div>;
  }

  if (!inspection) {
    return <div className="text-center py-12 text-gray-500">Inspección no encontrada</div>;
  }

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-900">Inspección #{inspection.id.slice(0, 8)}</h1>
        <div className="space-x-2">
          <Button variant="secondary" onClick={() => navigate('/')}>
            Volver
          </Button>
          <Button onClick={() => navigate(`/report/${id}`)}>
            Generar Reporte
          </Button>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-6 grid grid-cols-2 gap-4">
        <div>
          <p className="text-sm text-gray-500">Estado</p>
          <p className="font-medium">{inspection.status}</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">Checklist</p>
          <p className="font-medium">{inspection.checklistId}</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">Inspector</p>
          <p className="font-medium">{inspection.inspectorId}</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">Enviada</p>
          <p className="font-medium">{inspection.submittedAt ? new Date(inspection.submittedAt).toLocaleString() : 'Pendiente'}</p>
        </div>
        {inspection.location && (
          <div className="col-span-2">
            <p className="text-sm text-gray-500">Ubicación</p>
            <p className="font-medium">Lat: {inspection.location.lat}, Lng: {inspection.location.lng}</p>
          </div>
        )}
      </div>

      {inspection.answers && inspection.answers.length > 0 && (
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-lg font-medium text-gray-900 mb-4">Respuestas</h2>
          <ul className="space-y-2">
            {inspection.answers.map((a: { questionId: string; value: any }, i: number) => (
              <li key={i} className="border-b border-gray-100 pb-2">
                <p className="text-sm font-medium">Pregunta {i + 1}</p>
                <p className="text-sm text-gray-700">{JSON.stringify(a.value)}</p>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default InspectionPage;